import { Layout } from 'antd';
import HeaderBar from 'Layout/HeaderBar';
import FooterBar from 'Layout/FooterBar';
import MonitoringPageContent from './MonitoringPageContent';
import { useMonitoringOverview } from './useMonitoringOverview';
import AlertNavigation from './AlertNavigation';

const { Content } = Layout;

function MonitoringContainer() {
  const { data, isLoading, isError, error } = useMonitoringOverview();

  return (
    <Layout>
      <HeaderBar />
      <Content
        style={{
          margin: '24px 24px 0',
          padding: '0 24px',
        }}
      >
        <AlertNavigation active="legacy" />
        <p className="mb-4 text-sm text-muted-foreground">
          Denne oversigt viser den ældre overvågning. Kontrollér enhedens alarmopsætning i
          Enheder og dækning for at se, hvilket system der styrer dens alarmer.
        </p>
        {isLoading && (
          <div className="py-12 text-center text-sm text-muted-foreground">
            Indlæser overvågning...
          </div>
        )}
        {isError && (
          <div className="py-12 text-center text-sm text-red-600">
            Kunne ikke hente overvågning: {(error as Error)?.message}
          </div>
        )}
        {data && <MonitoringPageContent overview={data} />}
      </Content>
      <FooterBar />
    </Layout>
  );
}

export default MonitoringContainer;
